import axios from "axios";

export const deleteAccount = async (id, token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/deleteAccount/${id}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response?.data?.message);
    }
    if (error.request) {
    }
    throw new Error(error.message);
  }
};
